import { openNewTab } from '../../helpers';

export default function planVisitBtn() {
  const widgetName = 'funHereButton';
  const widgetOpts = funHereButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createFunButton(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createFunButton(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      $widget.remove();
      $('body').addClass(`${widgetName}-no-data`);
    } else {
      const targetElement = openNewTab(URL);
      $widget.replaceWith(
        `<a id="${widgetName}" class="button alternative-btn" tabindex="0" href="${URL}" ${targetElement}>${Title}</a>`,
      );
    }
  }
}
